<div class="edit-bet-cashout-message_container">
    <div class="edit-bet-cashout-message_icon">
        <vn-icon class="cashout-message-icon" name="theme-error-i" size="14" />
    </div>
    <div>{{ sitecoreMyBets.myBets.EditBetCashoutErrorMessage }}</div>
</div>
